import { render, staticRenderFns } from "./TenantSlimList.vue?vue&type=template&id=949bf23c&"
import script from "./TenantSlimList.vue?vue&type=script&lang=js&"
export * from "./TenantSlimList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports